import styled from 'styled-components'
import { MemberInvite } from '../MemberInvite'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 16px;
`

export const StyledMembersInvite = styled(MemberInvite)`
  background: none;
`
